import React from 'react';

type Props = {
  fill?: string;
  width?: string;
  height?: string;
};

const StateOverlayIcon: React.FC<Props> = ({ fill = '#F14157', width = '80', height = '56' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 80 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M80 7.22399V49C80 52.866 77.3303 56 74.0371 56H0C3.63886 24.3779 26.7231 0 54.6576 0C63.7941 0 72.4118 2.60782 80 7.22399Z"
        fill={fill}
        fillOpacity="0.12"
      />
    </svg>
  );
};

export default StateOverlayIcon;
